import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
	0% {
		scale: 0;
		opacity: 1;
	}
  20% {
    scale: 0.5;
    opacity: 0.5;
  }
	99% {
		scale: 1;
		opacity: 0;
	}
	100% {
    scale: 0;
    opacity: 0;
  }
`;

const StyledContainer = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	width: 50px;
	height: 50px;
	opacity: 0;
	transition:
		bottom 0.3s ease,
		opacity 0.3s ease;

	&.micro-enter {
		opacity: 0;
	}

	&.micro-enter-active,
	&.micro-enter-done,
	&.micro-exit {
		opacity: 1;
	}

	&.micro-exit-active {
		opacity: 0;
	}
`;

const StyledBackCircle = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
	width: 50px;
	height: 50px;
	border-radius: 50px;
	background-color: #ffffff;
	animation: ${pulse} 1.5s infinite ease-out;
`;

const StyledIconContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 30px;
	background-color: #ffffff;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}
`;

export { StyledContainer, StyledIconContainer, StyledBackCircle };
